import type { InvoiceV2PartyCompaniesResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  zodInvoiceV2PartyCompaniesBodySchema,
  zodInvoiceV2PartyCompaniesResponseSchema,
} from './validations';

/**
 * Resolves company ids to their current names, for the invoice list party
 * filters.
 *
 * Ids the caller cannot reach are omitted rather than reported, so the result
 * may be shorter than the request.
 *
 * @param companyIds - The companies to resolve.
 * @param options - Additional request options (e.g. abort signal).
 * @returns The companies that resolved.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/query_party_companies_invoices_companies_query_post
 */
export const fetchInvoiceV2PartyCompanies = async (
  companyIds: UUID[],
  options?: KyRequestOptions,
) => {
  return await vestigasApi
    .post(ENDPOINT.INVOICE.QUERY_PARTY_COMPANIES(), {
      ...options,
      json: { companyIds },
      validate: {
        ...options?.validate,
        body: zodInvoiceV2PartyCompaniesBodySchema,
        response: zodInvoiceV2PartyCompaniesResponseSchema,
      },
    })
    .json<InvoiceV2PartyCompaniesResponse>();
};
